<template>
  <div>
    <div style="display: flex; align-items: flex-start;">
      <piros-mogyoros-list/>
    </div>
  </div>
</template>

<script>
import PirosMogyorosList from '../../components/reports/pirosMogyoros/List';

export default {
  components: {
    PirosMogyorosList,
  },
  data() {
    return {

    }
  },
  computed: {

  },
  async mounted() {
    this.loading = true;
    this.loading = false;
  },
  methods: {

  }
};
</script>

<style lang="scss">
  .filter-container {
    padding: 20px;
    margin: -20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #EBEEF5;
  }
</style>
